import React, { Component } from 'react';
import _ from 'lodash';
import axios from 'axios';
import { API_URL } from '../../partials/Globals';
import Errors from '../../partials/Errors';
import Message from '../../partials/Message';
import Lightbox from '../../partials/Lightbox';
import Icon from '../../partials/Icon';
import Moment from 'react-moment';
import 'moment/locale/sv';

export default class StudentTransactions extends Component {
    state = {
        transactions: [],
        user: {
            first_name: ''
        },
        project: {
            pivot: {
                shares: 0
            }
        },
        sold: 0,
        waiting: 0,
        lightbox: false
    }

    constructor(props) {
        super(props);

        this.toggleLightbox = this.toggleLightbox.bind(this);
    }

    componentDidMount() {
        // Hämta projektet
        axios.get(API_URL+'/admin/groups/'+this.props.match.params.group_id+'/projects/'+this.props.match.params.project_id+'/users/'+this.props.match.params.user_id)
            .then(response => {
                console.log(response.data);
                this.setState({
                    user: response.data,
                    transactions: response.data.all_transactions
                });
                if (response.data.projects[0]) {
                    this.setState({ project: response.data.projects[0] });
                }
                // Räkna ut hur många som sålts och hur många som väntar
                if (response.data.all_transactions && response.data.all_transactions.length > 0) {
                    var sold = _.sumBy(response.data.all_transactions, (obj) => {
                        return obj.payment_success === 1 ? obj.shares : 0;
                    });
                    this.setState({ sold });

                    var waiting = _.sumBy(response.data.all_transactions, (obj) => {
                        return obj.payment_success === 0 ? obj.shares : 0;
                    });
                    this.setState({ waiting });
                } 
            });
    }

    toggleLightbox() {
        this.setState({ lightbox: (this.state.lightbox === true ? false: true) });
    }
    
    render() {
        const { transactions, user, project } = this.state;

        return (
            <div>
                <Lightbox open={ this.state.lightbox } toggle={ this.toggleLightbox } contents={ <div><h3>Antal andelar</h3><p>Det totala antalet andelar som deltagaren ska sälja.</p><hr /><h3>Sålda</h3><p>Antalet andelar som sålts.</p><hr /><h3>Väntande</h3><p>Antalet andelar i transaktioner som deltagaren gjort där kunden ännu inte klickat på länken i SMS:et och betalat.</p></div> } />

                <div className="top">
                    <div className="col-12">
                        <button className="back" onClick={ this.props.history.goBack }>Tillbaka</button>
                        <button className="lightbox-toggle" onClick={ this.toggleLightbox }></button>
                    </div>
                </div>

                <Errors errors={ this.state.errors } />
                <Message message={ this.state.message } />

                <div className="container">
                    <div className="content">
                        <h1>{ user.first_name }</h1>
                        <dl>
                            <dt>Antal andelar</dt> 
                                <dd>{ project.pivot.shares } st</dd>
                            <dt>Sålda</dt> 
                                <dd>{ this.state.sold } st</dd>
                            <dt>Väntande</dt> 
                                <dd>{ this.state.waiting } st</dd>
                        </dl>

                        <div className="block">
                            <div className="header">
                                <h4>Transaktioner</h4>
                            </div>
                            <div className="body">
                                { transactions && transactions.length > 0 ? (
                                    <ul className="has-icons compressed">
                                        { Object.keys(transactions).map(function(key) {
                                            return (
                                                <li key={ key }>
                                                    <Icon icon="transaction" color="pink" />

                                                    <span className="regular-text wrapper">
                                                        <span className="right small">
                                                            <Moment locale="sv" format="D/M">{ transactions[key].created_at }</Moment><br /> <Moment locale="sv" format="HH:mm">{ transactions[key].created_at }</Moment>
                                                        </span>
                                                        { transactions[key].payment_success === 0 ? (
                                                            <span>Påbörjade försäljning av { transactions[key].shares }</span>
                                                        ) : (
                                                            <span>Sålde { transactions[key].shares }</span>
                                                        ) } 
                                                        { transactions[key].shares === 1 ? (
                                                            <span> andel</span>
                                                        ) : (
                                                            <span> andelar</span>
                                                        ) }
                                                    </span>
                                                </li>
                                            )
                                        }) }
                                    </ul>
                                ) : (
                                    <span>Det finns inga transaktioner.</span>
                                ) }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/admin/Project/StudentTransactions.js